import { callWithNuxt } from "#app";
import { Modal } from "ant-design-vue";

export interface myFetchOptions {
    headers?: Record<string, string>

    [key: string]: any
}
export interface IApiResponse<T extends any> {
    data: T;
    code: number;
    message?: string;
    busCode?: string;
}

const getSsrForwardHeaders = () => {
    if (!import.meta.server) return {};
    // Only forward safe proxy headers for SSR requests
    const incoming = useRequestHeaders([
        "x-forwarded-for",
        "x-forwarded-proto",
        "x-forwarded-host",
        "x-real-ip",
    ]);
    return incoming || {};
}


export const getBaseUrl = () => {
    const config = useRuntimeConfig()
    if (config.public.baseServerApiUrl.indexOf('http') >= 0) {
        return config.public.baseServerApiUrl
    }
    if (import.meta.client) {
        return window.location.origin + config.public.baseServerApiUrl
    }
    const requestUrl = useRequestURL()
    return requestUrl.origin + config.public.baseServerApiUrl
}

const handleAuthExpired = async (
    response: any,
    nuxtApp: ReturnType<typeof useNuxtApp>,
    request?: any
) => {
    if (response?._data?.code !== -3) return false;
    const requestUrl =
        typeof request === "string"
            ? request
            : request?.url || request?.toString?.() || "";
    const requiresConfirm = requestUrl.includes("/Source/Action");
    if (import.meta.client) {
        if (requiresConfirm) {
            Modal.confirm({
                title: "登录提示",
                content: "登录已失效，是否前往登录？",
                okText: "去登录",
                cancelText: "暂不",
                onOk: () => {
                    window.location.href = "/users/login";
                },
            });
            return true;
        }
        window.location.href = "/users/login";
        return true;
    }
    await callWithNuxt(nuxtApp, navigateTo, [
        "/users/login",
        { replace: true, redirectCode: 401 }
    ]);
    return true;
}
export const useHttpFetch = (url: string, opt: myFetchOptions) => {
    //token
    const accessToken = useCookie('token')
    //添加请求头和token
    const headers = {
        ...opt.headers,
        ...getSsrForwardHeaders(),
        ...(accessToken.value ? { token: accessToken.value } : {})
    }
    opt.headers = headers
    const nuxtApp = useNuxtApp()
    let fullUrl = getBaseUrl() + url;
    console.log('fullUrl=' + fullUrl)
    return useFetch(fullUrl, {
        ...opt,
        onRequest({ request, options }) {
            console.log('request', request)
            console.log('requestparas', options.body)
            console.log('requestquery', options.query)
        },
        onRequestError({ request, options, error }) {
            // Handle the request errors
            console.log('onRequestError', request, error)
        },
        async onResponse({ request, response, options }) {

            await handleAuthExpired(response, nuxtApp, request);
            console.log('onResponse', request, response._data)

        },
        async onResponseError({ request, response, options }) {
            console.log('onResponseError', response.status)
            //未登录401状态
            if (response.status === 401) {
                if (import.meta.client) {
                    window.location.href = "/users/login";
                } else {
                    await callWithNuxt(nuxtApp, navigateTo, [
                        "/users/login",
                        { replace: true, redirectCode: 401 }
                    ])
                }
            } else if (response.status === 500) {
                console.log('服务器报错！！')
            }
        }
    })
}

export const $useHttpFetch = (url: string, opt: myFetchOptions) => {
    //token
    const accessToken = useCookie('token')
    //添加请求头和token
    const headers = {
        ...opt.headers,
        ...getSsrForwardHeaders(),
        ...(accessToken.value ? { token: accessToken.value } : {})
    }
    console.log("token", accessToken.value)
    opt.headers = headers
    const nuxtApp = useNuxtApp()
    let fullUrl = getBaseUrl() + url;
    console.log('fullUrl=' + fullUrl)
    return $fetch(fullUrl, {
        ...opt,
        onRequest({ request, options }) {
            console.log('$request', request)
            console.log('$requestparas', options.body)
        },
        onRequestError({ request, options, error }) {
            // Handle the request errors

        },
        async onResponse({ request, response, options }) {
            await handleAuthExpired(response, nuxtApp, request);
        },
        async onResponseError({ request, response, options }) {
            console.log('error', response.status)
            //未登录401状态
            if (response.status === 401) {
                if (import.meta.client) {
                    window.location.href = "/users/login";
                } else {
                    await callWithNuxt(nuxtApp, navigateTo, [
                        "/users/login",
                        { replace: true, redirectCode: 401 }
                    ])
                }
            } else if (response.status === 500) {
                console.log('服务器报错！！')
            }
        }
    })
}
